module.exports = __webpack_public_path__ + "img/banner-new-store-main-onnuri-kor.4c086718.png";